import React from 'react';

const Contact = () => {
    return (
        <div className="flex container  gap-10 p-2 md:mx-24 mt-12 font-semibold text-left">
            <div>
                Laura Tronge, Disability and Diversity Program Manager <br />
                DoDEA-Europe Director’s Office  <br />
                Unit 29649 <br />
                APO, AE 09136 <br />
                DSN: 314-545-1858 <br />
                Commercial: 0611-143-545-1858 <br />
                Commercial (US): +49 611-143-545-1858 <br />
            </div>

            <div>
                Cynthia Miller, EEO Team Lead <br />
                DoDEA-Europe Director’s Office<br />
                Unit 29649<br />
                APO, AE 09136<br />
                DSN: 314-545-1914<br />
                Commercial: 0611-143-545-1914<br />
                Commercial (US): +49 0611-143-545-1914<br />
            </div>

            <div>
                Robin Jamison, EEO Specialist<br />
                DoDEA-Europe Director’s Office<br />
                Unit 29649<br />
                APO, AE 09136<br />
                DSN: 314-545-1915<br />
                Commercial: 0611-143-545-1915<br />
                Commercial: +49 0611-143-545-1915<br />
            </div>
        </div>
    );
};

export default Contact;